
import { computed, ComputedRef, defineComponent } from 'vue';
import { TempBasketViewModel } from '@/shared/checkout/basket/temp-basket-api';
import ProductLineItem from '@/b2b/shared/product/ui/ProductLineItem.vue';
import basketStore from '@/shared/checkout/basket/basket.store';
import utilities from '@/shared/utilities.service';

export default defineComponent({
    name: 'MiniBasketArea',
    components: { ProductLineItem },
    setup() {
        const basket: ComputedRef<TempBasketViewModel> = computed(() => {
            return basketStore.basket;
        });

        const products = computed(() => {
            return utilities.toggleCollectionCap(basket.value.lineItems, 2, false);
        });

        return {
            basket,
            products,
        };
    },
});
